<template>
    <v-form :name="searchProps.formName"
            @keyup.enter="autoSearch = true">
        <Tabs value="0"
              scrollable>

            <TabList>
                <Tab value="0">{{ __('Search condition') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormInputText fieldName="category_name"
                                       label="Category name"
                                       size="8"
                                       :isFocus="true"
                                       v-model:field="search.category_name" />
                        <FormInputText fieldName="symbol"
                                       label="Symbol"
                                       size="2"
                                       v-model:field="search.symbol" />

                        <FormSelect fieldName="protocol_type"
                                    label="Protocol type"
                                    size="2"
                                    :options="select?.protocoltypes"
                                    v-model:field="search.protocol_type" />
                    </div>
                </TabPanel>
            </TabPanels>
        </Tabs>


        <div class="grid">
            <SearchButtons :searchProps="searchProps"
                           :search="search"
                           v-model:autoSearch="autoSearch" />
        </div>
    </v-form>
</template>

<script setup>
import { ref } from "vue";

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormInputText from '@crud/FormInputText.vue'
import FormSelect from '@crud/FormSelect.vue'
import SearchButtons from '@crud/SearchButtons.vue'
import { prepareSearch } from '@pages/Helper/crud_utils.js'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    searchProps: Object,
})

const autoSearch = ref(false)
const options = ["protocoltypes"];
const select = ref(null);

let search = ref({})
prepareSearch(search, props, options, select)

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
